import type { PackagingState } from './toyPackaging'

// Upload state shared by every "Make X" route. Each route owns its own
// React state slot of this type; the `idle` and `collecting` phases live
// in the route, and the packager itself drives the `PackagingState` half.
export type UploadState =
  | { status: 'idle' }
  | { status: 'collecting' }
  | PackagingState

// Returns true when the UI should consider the upload pipeline busy
// (collecting details, preparing the package, or actively uploading).
// Routes with extra in-flight states (e.g. ABC's `tts`) compose this
// with their own checks rather than extending the union here.
export function isUploadWorking(state: { status: string }): boolean {
  return (
    state.status === 'collecting' ||
    state.status === 'preparing' ||
    state.status === 'uploading'
  )
}
